import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography} from 'views/components';
import {Check, Info} from 'views/icons';
import {Translate} from 'views/module';

import moment from 'moment';

const AvailabilitySection = (props) => {
  const {
    availabilityData,
  } = props;

  return (
    <Stack
      direction="column"
      spacing={2}
      width='100%'
      sx={{}}
    >
      <Stack
        spacing= {{xs: 2, md: 4}}
        sx={{
          py: {xs: 2, md: 2},
          px: {xs: 2, md: 3},
          bgcolor: 'color.white',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'color.divider',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Stack
          direction={{xs: 'column', md: 'row'}}
          spacing={{xs: 1, md: 0}}
          justifyContent="space-between"
          alignItems={{xs: 'flex-start', md: 'center'}}
        >
          <Typography
            variant="body1"
            fontWeight="bold"
            sx={{
              color: '#686868',
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
            }}
          >
            <Translate
              expression="caregiverDetail.Availability.CardTitle"
            />
          </Typography>
          {
            availabilityData.availabilityLastUpdatedTime &&
            <Typography
              variant="body2"
              fontWeight="400"
              fontStyle="italic"
              sx={{
                color: '#818181',
                letterSpacing: '0.04em',
              }}
            >
              <Translate
                expression="caregiverDetail.Availability.LastUpdated"
                substitute={{lastUpdated: moment(availabilityData.availabilityLastUpdatedTime).format('MMM D, YYYY')}}
              />
            </Typography>
          }
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{
            bgcolor: '#F9F5F2A6',
            py: {xs: 2, md: 2},
            px: {xs: 2, md: 3},
            borderRadius: 2,
          }}
        >
          <Check sx={{color: 'success.main', fontSize: 20}} />
          <Typography variant="body1" color="text.primary">
            {availabilityData.availability}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        sx={{
          py: {xs: 2, md: 2},
          px: {xs: 3, md: 3},
          bgcolor: 'color.white',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'color.divider',
          width: '100%',
          boxSizing: 'border-box',
          alignItems: 'flex-start',
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
        >
          <Info sx={{color: '#DA7955CC', fontSize: 20}} />
          <Typography variant="body2" color="text.primary" fontWeight={{xs: '400', md: '600'}}>
            <Translate
              expression="caregiverDetail.Availability.Blurb"
            />
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

AvailabilitySection.propTypes = {
  availabilityData: PropTypes.object.isRequired,
};

export default React.memo(AvailabilitySection);
